import { render } from "./PlatformNavbar.vue?vue&type=template&id=49d312df&scoped=true&ts=true"
import script from "./PlatformNavbar.vue?vue&type=script&lang=ts"
export * from "./PlatformNavbar.vue?vue&type=script&lang=ts"

import "./PlatformNavbar.vue?vue&type=style&index=0&id=49d312df&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d312df"]])

export default __exports__